import './Footer.css';
import useScrollToTop from '../ScrollToTop/useScrollToTop';
import skillsyncLogo from '../../assets/skillsync-logo.png';

export default function Footer() {
  const year      = new Date().getFullYear();
  const handleNav = useScrollToTop();

  return (
    <footer id="contact" className="footer">

      {/* ── Floating CTA Card ── */}
      <div className="footer-cta-band">
        <div className="footer-cta-inner">
          <div className="footer-cta-text">
            <div className="footer-cta-eyebrow">Ready To Create Memories?</div>
            <h2 className="footer-cta-heading">
              Let's Capture Your <em>Story.</em>
            </h2>
            <div className="footer-cta-checks">
              <span className="footer-cta-check">Wedding &amp; Events</span>
              <span className="footer-cta-check">Same-Day Delivery</span>
              <span className="footer-cta-check">Pan Tamil Nadu</span>
            </div>
          </div>
          <div className="footer-cta-actions">
            
            <a href="contact" className="footer-cta-btn footer-cta-btn-secondary">
              Contact Us <span className="btn-arrow">→</span>
            </a>
          </div>
        </div>
      </div>

      {/* ── Main Footer ── */}
      <div className="footer-main">

        {/* Brand */}
        <div className="footer-brand">
          <div className="footer-logo">
            <span className="footer-logo-main">BRAND<span>PARTNER</span></span>
            <span className="footer-logo-sub">Studio and Gifts</span>
          </div>
          <p className="footer-tagline">
            Capturing timeless moments with a cinematic eye — across Tamil Nadu and beyond.
          </p>
          <div className="footer-socials">
            <a href="https://www.instagram.com/brandpartnersphotography/" target="_blank" rel="noreferrer" aria-label="Instagram">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="16" height="16">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                <circle cx="12" cy="12" r="4"/>
                <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" stroke="none"/>
              </svg>
            </a>
            <a href="https://www.youtube.com/@brandpartners5095" target="_blank" rel="noreferrer" aria-label="YouTube">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="16" height="16">
                <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.97C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 0 0-1.95 1.96A29 29 0 0 0 1 12a29 29 0 0 0 .46 5.57 2.78 2.78 0 0 0 1.95 1.97C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.96-1.97A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/>
                <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02"/>
              </svg>
            </a>
            <a href="https://wa.me/919600998798" target="_blank" rel="noreferrer" aria-label="WhatsApp">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="16" height="16">
                <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
              </svg>
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-col">
          <div className="footer-col-title">Quick Links</div>
          <ul className="footer-links">
            <li><button onClick={() => handleNav('/')}>Home</button></li>
            <li><button onClick={() => handleNav('/about')}>About Us</button></li>
            <li><button onClick={() => handleNav('/services')}>Services</button></li>
            <li><button onClick={() => handleNav('/portfolio')}>Portfolio</button></li>
            <li><button onClick={() => handleNav('/contact')}>Contact</button></li>
          </ul>
        </div>

        {/* Services */}
        <div className="footer-col">
          <div className="footer-col-title">Services</div>
          <ul className="footer-links">
            <li><button onClick={() => handleNav('/wedding')}>Wedding Photography</button></li>
            <li><button onClick={() => handleNav('/cinematic')}>Cinematic Videography</button></li>
            <li><button onClick={() => handleNav('/babyshoot')}>Baby &amp; Newborn Shoot</button></li>
            <li><button onClick={() => handleNav('/maternity')}>Maternity Photography</button></li>
            <li><button onClick={() => handleNav('/prewedding')}>Pre-Wedding Shoot</button></li>
            <li><button onClick={() => handleNav('/bharatanatyam')}>Bharatanatyam</button></li>
            <li><button onClick={() => handleNav('/corporate')}>Corporate Events</button></li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-col footer-contact-col">
          <div className="footer-col-title">Contact Us</div>
          <div className="footer-contact-list">
            <div className="footer-contact-item">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" width="13" height="13" style={{flexShrink:0}}>
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.65 3.21 2 2 0 0 1 3.6 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.55a16 16 0 0 0 6.05 6.05l1.01-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
              </svg>
              <div className="footer-contact-phones">
                <a href="tel:+918940639672">+91 89406 39672</a>
                <a href="tel:+919600998798">+91 96009 98798</a>
              </div>
            </div>
            <div className="footer-contact-item">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" width="13" height="13" style={{flexShrink:0}}>
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
              <a href="mailto:info@brandpartner.in">info@brandpartner.in</a>
            </div>
            <div className="footer-contact-item">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" width="13" height="13" style={{flexShrink:0}}>
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                <circle cx="12" cy="10" r="3"/>
              </svg>
              <span>ID Cave Street, Duthi Scl Rd, Nagercoil, Tamil Nadu</span>
            </div>
            <div className="footer-contact-item">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" width="13" height="13" style={{flexShrink:0}}>
                <circle cx="12" cy="12" r="10"/>
                <polyline points="12 6 12 12 16 14"/>
              </svg>
              <span>Mon – Sat: 9am – 7pm</span>
            </div>
          </div>
        </div>

      </div>

      {/* Divider */}
      <div className="footer-divider" />

      {/* Bottom bar */}
      <div className="footer-bottom">
        <span className="footer-copy">
          © {year} Brand Partner Studio. All rights reserved.
        </span>
        <div className="footer-bottom-links">
          <a href="#privacy">Privacy</a>
          <span className="footer-bottom-sep">·</span>
          <a href="#terms">Terms</a>
        </div>
        <div className="footer-status">
          <span className="footer-status-dot" />
          Studio Open
        </div>
      </div>

      {/* Built by Skillsync Section */}
      <div className="footer-built-by">
        <span className="footer-built-by-text">
          <img src={skillsyncLogo} alt="Skillsync Logo" className="footer-skillsync-logo" />
          Built by SKILLSYNC Pro Pvt Ltd
        </span>
      </div>

    </footer>
  );
}
